import Vue from 'vue'
import Router from 'vue-router'
import iView from 'iview';
import i18n from '../plugins/i18n'

Vue.use(Router);

const router = new Router({
    base: process.env.BASE_URL,
    mode: 'history',
    scrollBehavior(to, from, savedPosition) {
        return {x: 0, y: 0}
    },
    routes: [{
        path: '/',
        name: 'home',
        component: () => import('../pages/home/Index.vue'),
        meta: {
            // header_hide:true,
            footer_hide: true,
            title: i18n.t('common.NBHX'),
        }
    }, {
        path: '/corporateGovernance',
        name: 'corporateGovernance',
        component: () => import('../pages/corporateGovernance/Index.vue'),
        meta: {
            title: i18n.t('common.公司治理'),
        }
    }, {
        path: '/about',
        name: 'about',
        component: () => import('../pages/about/Index.vue'),
        meta: {
            title: i18n.t('common.关于华翔'),
        },

    }, {
        path: '/contact',
        name: 'contact',
        component: () => import('../pages/about/Contact.vue'),
        meta: {
            title: i18n.t('common.联系我们'),
        },

    }, {
        path: '/globalDistribution',
        name: 'globalDistribution',
        component: () => import('../pages/about/GlobalDistribution.vue'),
        meta: {
            title: i18n.t('common.全球分布'),
        },
    }, {
        path: '/product',
        name: 'product',
        component: () => import('../pages/product/Index.vue'),
        meta: {
            title: i18n.t('common.核心业务'),
        },
    }, {
        path: '/productDetail',
        name: 'productDetail',
        component: () => import('../pages/product/Product.vue'),
        meta: {
            title: i18n.t('common.核心业务'),
        },
    },
        {
            path: '/talentsDevelopment',
            name: 'talentsDevelopment',
            component: () => import('../pages/manpowerResource/Talents.vue'),
            meta: {
                title: i18n.t('common.人才发展'),
            },

        },
        {
            path: '/partnership',
            name: 'partnership',
            component: () => import('../pages/partnership/Index.vue'),
            meta: {
                title: i18n.t('common.合作伙伴'),
            },

        }, {
            path: '/news',
            name: 'news',
            component: () => import('../pages/news/Index.vue'),
            meta: {
                title: i18n.t('common.媒体报道'),
            },
        }, {
            path: '/newsDetail',
            name: 'newsDetail',
            component: () => import('../pages/news/Detail.vue'),
            meta: {
                title: i18n.t('common.NBHX'),
            },
        }, {
            path: '/NBHXnews',
            name: 'NBHXnews',
            component: () => import('../pages/news/Enterprise.vue'),
            meta: {
                title: i18n.t('common.企业新闻')
            }
        }, {
            path: '/business',
            name: 'business',
            component: () => import('../pages/news/Business.vue'),
            meta: {
                title: i18n.t('common.行业动态')
            }
        }, {
            path: '/client',
            name: 'client',
            component: () => import('../pages/about/Client.vue'),
            meta: {
                title: i18n.t('common.主要客户')
            }
        }, {
            path: '/award',
            name: 'award',
            component: () => import('../pages/about/Award.vue'),
            meta: {
                title: i18n.t('common.荣誉奖项')
            }
        }, {
            path: '/integrity',
            name: 'integrity',
            component: () => import('../pages/about/Integrity.vue'),
            meta: {
                title: i18n.t('廉正合规')
            }
        }
    ]
});

router.beforeEach((to, from, next) => {
    iView.LoadingBar.start();
    if (to.meta.title)
        document.title = to.meta.title;
    //百度统计
    if (window._hmt) {
        if (to.path) {
            window._hmt.push(['_trackPageview', process.env.BASE_URL + to.fullPath]);
        }
    }
    next();
});

router.afterEach(() => {
    iView.LoadingBar.finish();

});

export default router
